class YoptoStars extends window.BAO.CustomElement() {
  connectedCallback () {
    // Add event listener for the custom element itself
    this.addEventListener('click', this.handleYoptoStarsClick)

    // Ensure that the click event on any <a> tag inside this custom element propagates to the parent
    this.querySelectorAll('a').forEach(anchor => {
      anchor.addEventListener('click', e => {
        e.preventDefault() // Prevent the default behavior, which is navigation
        this.handleYoptoStarsClick(e) // Manually call the handler
      })
    })
  }

  handleYoptoStarsClick (e) {
    const yotpoReviewsMainWidget = document.querySelector(
      '#yotpo-reviews-main-widget',
    )

    yotpoReviewsMainWidget?.scrollIntoView({ behavior: 'smooth' })
  }
}

if (!customElements.get('yopto-stars')) {
  customElements.define('yopto-stars', YoptoStars)
}
